import type { Locale } from 'date-fns';
import { enGB } from 'date-fns/locale';
import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

const fallbackLng = 'en';

const lngs: {
  [code: string]: {
    nativeName: string;
    locale: Locale;
  };
} = {
  en: { nativeName: 'English', locale: enGB },
};

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    supportedLngs: Object.keys(lngs),
    fallbackLng,
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    nsSeparator: ':',
    returnNull: false,
  });

export default i18n;
